import Mock from "../mock";

const database = {
  information: {
    name: 'Shailesh Nayak',
    legalName: 'Kuradi Shailesh Nayak',
    tagline: 'Full Stack Application Engineer. Converts caffeine to code.',
    aboutContent: "Full Stack Application Engineer. Converts caffeine to code.",
    age: 26,
    phone: '+1 669 292 8024',
    nationality: 'Indian',
    language: 'English, Hindi',
    email: 'nayak.shaileshnayak@gmail.com',
    address: '190 Ryland Street, San Jose, California, USA',
    status: 'Open to Hire',
    socialLinks: {
      facebook: 'https://www.facebook.com/shaileshnayak07',
      twitter: '',
      pinterest: '',
      behance: '',
      linkedin: 'https://www.linkedin.com/in/shailesh-nayak-k/',
      dribbble: '',
      github: 'https://github.com/shailesh-nyk'
    },
    brandImage: '/images/brand-image.jpg',
    aboutImage: '/images/about-image.jpg',
    aboutImageLg: '/images/about-image-lg.jpg',
    cvfile: '/files/SHAILESH_NAYAK_Resume.pdf'
  },
  services: [
    {
      title: "Web Development",
      icon: 'code-alt',
      details: "React, Redux, Angular2+, HTML5, CSS3, Bootstrap, SASS"
    },
    {
      title: "RESTful API Development",
      icon: 'code',
      details: "Node.JS, Python Flask, Apache Kafka, RabbitMQ, Kong, Socket.io"
    },
    {
      title: "Mobile application Development",
      icon: 'mobile',
      details: "React Native, Expo, Apache Cordova, PhoneGap"
    },
    {
      title: "Data Management",
      icon: 'database',
      details: "Relational and NoSQL Database management and design. MongoDB, MySQL, Redis, SOLR, Amazon RDS, Amazon S3"
    },
    {
      title: "Cloud Infrastructure",
      icon: 'cloud-network',
      details: "Docker, AWS, GCP, Kubernetes"
    }
  ],
  reviews: [
    {
      id: 1,
      content: "I had the pleasure of working with Shailesh in the same team for 2 years. During this time, his positive attitude and appetite for learning is what set him apart. The skills that often take years to develop among professionals, seemed to come perfectly natural to him. As a team member or a leader, Shailesh earns my highest recommendation.",
      author: {
        name: 'Vinay Patil',
        designation: 'Software Engineer, Bloomberg'
      }
    },
    {
      id: 2,
      content: "Among the brightest of any lot. Has the ability to lead any pack. Has a very simple, modest and logical work around for any task at hand. A great leader and a strong team player which would help the growth of any organisation. Has a great understanding and deep knowledge on applications development in conjunction with a logical approach for the same.",
      author: {
        name: 'Akshay Pai',
        designation: 'SDE II , Oracle'
      }
    },
    {
      id: 3,
      content: "Shailesh is an extremely intelligent and hard working individual. He has exceptional mathematical and logical thinking skills. It goes without saying that he clearly would add in abundance to any organization he joins , with the technical and non-technical skill set that he possesses. He is a quick learner who is extremely adaptive , be it in a group or a leadership role. I would also like to highlight that he has quite a few accolades in a variety of sports.",
      author: {
        name: 'Abhishek Kuckian',
        designation: 'Operations Officer, AlphaVision International (Self-employed)'
      }
    }
  ],
  skills: [
    {
      title: "HTML5",
      value: 85
    },
    {
      title: "CSS3",
      value: 75
    },
    {
      title: "Javascript (ES6)",
      value: 90
    },
    {
      title: "ReactJS",
      value: 90
    },
    {
      title: "AngularJS",
      value: 80
    },
    {
      title: "Node.JS",
      value: 85
    },
    {
      title: "MongoDB",
      value: 80
    },
    {
      title: "MySQL",
      value: 65
    },
    {
      title: "Docker",
      value: 65
    },
    {
      title: "Kubernetes",
      value: 50
    }
  ],
  portfolios: [
    {
      id: 7,
      title: "Bitly Clone",
      subtitle: "Cloud-scale clone of the popular URL shortening service",
      fileName: 'bitly.md',
      imageUrl: "/images/bitly.png",
      stack: [
        { name: "GO", icon: "code"},
        { name: "RabbitMQ", icon: "shuffle"},
        { name: "Docker", icon: "docker"},
        { name: "Kubernetes", icon: "cog"},
        { name: "AWS EC2", icon: "aws"},
        { name: "GCP", icon: "google"},
        { name: "Kong API Gateway", icon: "direction"},
        { name: "React", icon: "react"},
        { name: "Heroku", icon: "cloud"},
      ],
      links: [
      ],
      videoURL: "https://youtu.be/tMo0fDY5_Ro",
    },
    {
      id: 1,
      title: "ALIMO",
      subtitle: "iOS & Android eCommerce application.",
      imageUrl: "/images/alimo.png",
      fileName: 'alimo.md',
      stack: [
        { name: "React Native", icon: "react"},
        { name: "Redux", icon: "layers"},
        { name: "Node.JS Cloud Functions", icon: "nodejs-alt"},
        { name: "Google Firebase", icon: "google"},
        { name: "Stripe Payments", icon: "stripe"},
        { name: "Google Cloud Messaging", icon: "bullhorn"},
      ],
      links: [
        { icon : 'play-store' , url : "https://play.google.com/store/apps/details?id=com.aliferrari.app" },
        { icon : 'app-store' , url : "https://apps.apple.com/us/app/id1524397746" }
      ]
    },
    {
      id: 2,
      title: "Twitter Clone",
      subtitle: "A 3-tier distributed social media application.",
      imageUrl: "/images/twitter/twitter-clone.png",
      fileName: 'twitter.md',
      videoURL: "https://youtu.be/1T6gZyKfpcE",
      stack: [
        { name: "React", icon: "react"},
        { name: "Redux", icon: "code"},
        { name: "Node.JS", icon: "nodejs"},
        { name: "MongoDB", icon: "leaf"},
        { name: "Apache Kafka", icon: "code"},
        { name: "Redis", icon: "layers"},
        { name: "AWS S3", icon: "aws"},
      ],
      links: [
        { icon : 'github' , url : "https://github.com/shailesh-nyk/Twitter_SANAF" }
      ]
    },
    {
      id: 6,
      title: "Distributed Key-Value DB",
      subtitle: "REST API based 5-node document store",
      fileName: 'nosql.md',
      imageUrl: "/images/nosql.png",
      stack: [
        { name: "Java", icon: "java"},
        { name: "Restlet", icon: "java"},
        { name: "Docker", icon: "docker"},
      ],
      links: [
      ],
      videoURL: "https://youtu.be/bALj9NbGZRE",
    },
    {
      id: 3,
      title: "Dataverse",
      subtitle: "A scalable, decentralized & distributed file storage solution",
      imageUrl: "/images/dataverse.png",
      fileName: 'dataverse.md',
      videoURL: "https://youtu.be/dNCXMMdeFc4",
      stack: [
        { name: "Python Flask API", icon: "python"},
        { name: "RAFT Leader election", icon: "network"},
        { name: "gRPC", icon: "arrows-horizontal"},
        { name: "React Frontend", icon: "react"},
        { name: "AWS S3", icon: "aws"},
      ],
      links: [
        { icon : 'github' , url : "https://github.com/shailesh-nyk/dataverseproject" }
      ]
    },
    {
      id: 4,
      title: "Minesweeper",
      subtitle: "A simple single-player puzzle video game.",
      fileName: 'minesweeper.md',
      imageUrl: "/images/minesweeper.jpg",
      stack: [
        { name: "HTML5", icon: "html5"},
        { name: "CSS3", icon: "css3"},
        { name: "JavaScript", icon: "javascript"},
      ],
      links: [
        { icon : 'github' , url : "https://github.com/shailesh-nyk/Minesweeper" }
      ]
    },
    {
      id: 5,
      title: "Llama World",
      subtitle: "A informational site about Llamas",
      fileName: 'llama.md',
      imageUrl: "/images/llama.png",
      stack: [
        { name: "React", icon: "react"},
        { name: "Bootstrap", icon: "bootstrap"},
        { name: "Twitter API for trends", icon: "twitter-filled"},
        { name: "Heroku PaaS", icon: "cloud"},
      ],
      links: [
        { icon : 'github' , url : "https://github.com/shailesh-nyk/Llama-World" }
      ]
    }
  ],
  experience: {
    workingExperience: [
      {
        id: 1,
        year: "May 2020 - Present",
        position: "Software Developer Intern",
        company: "SAP Labs Inc.",
        details: [
          "Part of a fast-paced and dynamic ‘Emerging Technologies and Strategic Innovation’ team.",
          "Rapid prototyping multiple full stack applications for the Digital Supply Chain business using React/Redux, Material-UI, NodeJS, D3.js, HANA.",
          "Curating data pipelines using SAP Data Intelligence tool to gain value from heterogenous data sources."
        ]
      },
      {
        id: 2,
        year: "Jan 2020 - May 2020",
        position: "Research Assistant",
        company: "San Jose State University Research Foundation",
        details: [
          "Built a comprehensive data visualization & analysis tool for a semiconductor manufacturer achieving >40% increase in performance from legacy solution. The tool is responsible for continuously parsing log files from industrial machines and visualize data, provide alerts and insights.",
          "Designed and Developed an IT monitoring system which would be shipped alongside the data analysis tool for remote configuration and control of the services pertaining to it."
        ]
      },
      {
        id: 3,
        year: "Feb 2018 - July 2019",
        position: "Software Development Engineer",
        company: "SonicWall Inc. (Previously DELL SonicWall)",
        details: [
          "Developed a unified UI framework collaborating with UX team to propel front-end development across different teams in the firm.",
          "Ownership of key features in the migration of legacy site to Angular with a performance increase of >30%.",
          "Planned and designed cross-functional implementations into existing project introducing SSO and Single Pane of Glass interface.",
          "Trained peers with Angular and related technologies during the initial phases of the migration from legacy."
        ]
      },
      {
        id: 4,
        year: "July 2016 - Jan 2018",
        position: "Software Development Associate Engineer",
        company: "SonicWall Inc. (Previously DELL SonicWall)",
        details: [
          "Took initiative in pointing out bottlenecks and subsequently improved site performance.",
          "Lead a self-initiated project to introduce responsive design into legacy application using CSS Media Queries.",
          "As a part of an individual R&D project, designed and developed a Proof of Concept for a test automation framework for cross-platform testing of mobile apps using Appium.",
          "To overcome the absence of native mobile app developers in the team, developed a Proof of Concept for a Hybrid Mobile Application using Apache Cordova/PhoneGap."
        ]
      }
    ],
    educationExperience: [
      {
        id: 1,
        year: "2019 - 2021(expected)",
        graduation: "Master of Science - Software Engineering",
        university: "San Jose State University",
        details: [
          "Specializing in Enterprise Software and Cloud Technology.",
          "Coursework: Distributed Systems, Cloud Technologies, Data Mining, Software Design Patterns",
        ]
      },
      {
        id: 2,
        year: "2012 - 2016",
        graduation: "Bachelor of Engineering - Computer Science",
        university: "Visvesvaraya Technological University",
        details: [
          "Coursework: Data Structures, Algorithms, Operating Systems, RDBMS, OOPS, Web Technologies",
          "Member of university Handball team & Gold medallist in university-level handball competition.",
          "Core committee member of the college tech fest, organized workshops and managed events with footfall of 300-500"
        ]
      }
    ]
  },
  blogs: [
    {
      id: 1,
      title: 'Markdown & Html supported blog.',
      featuredImage: '/images/blog-image-1.jpg',
      filesource: '../../blog/markdown-html-supported-blog.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 2,
      title: 'Installing NodeJS on your device.',
      featuredImage: '/images/blog-image-2.jpg',
      filesource: '../../blog/installing-nodejs-on-your-device.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 3,
      title: 'UI/UX design starter with Adobe XD.',
      featuredImage: '/images/blog-image-3.jpg',
      filesource: '../../blog/uiux-design-starter-with-adobe-xd.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 4,
      title: 'Boost your post for increasing sales.',
      featuredImage: '/images/blog-image-4.jpg',
      filesource: '../../blog/boost-your-post-for-increasing-sales.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 5,
      title: 'Difference between GatsbyJS & NextJS.',
      featuredImage: '/images/blog-image-5.jpg',
      filesource: '../../blog/difference-between-gatsbyjs-and-nextjs.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 6,
      title: 'How to choose javascript framework for project.',
      featuredImage: '/images/blog-image-6.jpg',
      filesource: '../../blog/how-to-choose-javascript-framework-for-project.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 7,
      title: 'Web automation with python language.',
      featuredImage: '/images/blog-image-7.jpg',
      filesource: '../../blog/web-automation-with-python-language.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 8,
      title: 'Time to use latest technology for creating a website.',
      featuredImage: '/images/blog-image-8.jpg',
      filesource: '../../blog/time-to-use-latest-technology-for-creating-a-website.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 9,
      title: 'Think out of the box.',
      featuredImage: '/images/blog-image-9.jpg',
      filesource: '../../blog/think-out-of-the-box.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 10,
      title: 'Trending designs in 2020.',
      featuredImage: '/images/blog-image-1.jpg',
      filesource: '../../blog/trending-designs-in-2020.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 11,
      title: 'How to get 10k instagram followers?',
      featuredImage: '/images/blog-image-2.jpg',
      filesource: '../../blog/how-to-get-10k-instagram-followers.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 12,
      title: 'What NodeJS can do?',
      featuredImage: '/images/blog-image-3.jpg',
      filesource: '../../blog/what-nodejs-can-do.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 13,
      title: 'Futures of javascript.',
      featuredImage: '/images/blog-image-4.jpg',
      filesource: '../../blog/future-of-javascript.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 14,
      title: 'Popular javascript library in 2020.',
      featuredImage: '/images/blog-image-5.jpg',
      filesource: '../../blog/popular-javascript-library-in-2020.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    },
    {
      id: 15,
      title: 'Promrammers must read books.',
      featuredImage: '/images/blog-image-6.jpg',
      filesource: '../../blog/programmers-must-read-books.md',
      createDay: "20",
      createMonth: 'February',
      createYear: "2020"
    }
  ],
  contactInfo: {
    phoneNumbers: ['+1 669 292 8024'],
    emailAddress: ['nayak.shaileshnayak@gmail.com', 'kuradishailesh.nayak@sjsu.edu'],
    address: "190 Ryland Street, San Jose, California, USA 95110"
  }
}


Mock.onGet("/api/information").reply(config => {
  const response = database.information;
  return [200, response];
});

Mock.onGet("/api/services").reply(config => {
  const response = database.services;
  return [200, response];
});

Mock.onGet("/api/reviews").reply(config => {
  const response = database.reviews;
  return [200, response];
});

Mock.onGet("/api/skills").reply(config => {
  const response = database.skills;
  return [200, response];
});

Mock.onGet("/api/portfolios").reply(config => {
  const response = database.portfolios;
  return [200, response];
});


Mock.onGet("/api/experience").reply(config => {
  const response = database.experience;
  return [200, response];
});

Mock.onGet("/api/blog").reply(config => {
  const response = database.blogs;
  return [200, response];
});

Mock.onGet("/api/contactinfo").reply(config => {
  const response = database.contactInfo;
  return [200, response];
});